import React from 'react';
import { useTranslation } from 'react-i18next';

const Terms: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="booking-main">
      <div className="booking-contant">
        <div className="container">
          <div style={{ padding: '20px' }}>
            <div className="card-body">
              <h2>{t('label-title.terms-and-conditions')}</h2>
              <p>Terms and conditions content goes here...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;



